/* Copyright (c) 2020-present CloudIO Inc */

import { Item } from '../../registry/Component.type';
import { data } from './SampleCSVData';

export const page: {
  root: Item<'Page'>;
  dataGrid: Item<'DataGrid'>;
  localDataStore: Item<'LocalDataStore'>;
  dataStoreReference: Item<'DataStoreReference'>;
  stringColumn: Item<'StringColumn'>;
  dateColumn: Item<'DateColumn'>;
  numberColumn: Item<'NumberColumn'>;
  checkboxColumn: Item<'CheckboxColumn'>;
} = {
  checkboxColumn: {
    children: [],
    itemId: 'checkboxColumn',
    parent: 'dataGrid',
    props: {
      insertable: {
        type: 'boolean',
        value: true,
      },
      label: { type: 'text', value: 'Boolean' },
      updatable: {
        type: 'boolean',
        value: true,
      },
      viewAttribute: 'active',
      width: 120,
    },
    type: 'CheckboxColumn',
  },
  dataGrid: {
    children: ['stringColumn', 'dateColumn', 'numberColumn', 'checkboxColumn'],
    itemId: 'dataGrid',
    parent: 'dataStoreReference',
    props: {
      insertable: {
        type: 'boolean',
        value: true,
      },
      updatable: {
        type: 'boolean',
        value: true,
      },
    },
    type: 'DataGrid',
  },
  dataStoreReference: {
    children: ['dataGrid'],
    itemId: 'dataStoreReference',
    parent: 'root',
    props: {
      alias: 'test',
    },
    type: 'DataStoreReference',
  },
  dateColumn: {
    children: [],
    itemId: 'dateColumn',
    parent: 'dataGrid',
    props: {
      insertable: {
        type: 'boolean',
        value: true,
      },
      label: { type: 'text', value: 'Date' },
      updatable: {
        type: 'boolean',
        value: true,
      },
      viewAttribute: 'someDate',
      width: 150,
    },
    type: 'DateColumn',
  },
  localDataStore: {
    children: [],
    itemId: 'localDataStore',
    parent: 'root',
    props: {
      alias: 'test',
      data,
      dataSource: 'test',
    },
    type: 'LocalDataStore',
  },
  numberColumn: {
    children: [],
    itemId: 'numberColumn',
    parent: 'dataGrid',
    props: {
      insertable: {
        type: 'boolean',
        value: true,
      },
      label: { type: 'text', value: 'Number' },
      updatable: {
        type: 'boolean',
        value: true,
      },
      viewAttribute: 'someNumber',
      width: 120,
    },
    type: 'NumberColumn',
  },
  root: {
    children: ['localDataStore', 'dataStoreReference'],
    itemId: 'root',
    parent: 'root',
    props: {
      windowTitle: {
        type: 'text',
        value: 'CloudIO Help',
      },
    },
    type: 'Page',
  },
  stringColumn: {
    children: [],
    itemId: 'stringColumn',
    parent: 'dataGrid',
    props: {
      insertable: {
        type: 'boolean',
        value: true,
      },
      label: { type: 'text', value: 'Name' },
      updatable: {
        type: 'boolean',
        value: true,
      },
      viewAttribute: 'name',
      width: 200,
    },
    type: 'StringColumn',
  },
};
